import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import CropperImage from "../CropperImage";
import { useIntl } from "react-intl";
import { temp_store } from "../../../modules/function/temp_store"


export const CreatePrefile = (props) => {
    const intl = useIntl();
    const suhbeader = useSubheader();
    suhbeader.setTitle('Create Presentation File');
    const history = useHistory();

    const [item_image_path, setItem_image_path] = useState();
    const [nameImageItem_image_path, setNameImageItem_image_path] = useState("");
    const [listpreType, setListpreType] = useState();
    const [preTypeID, setPreTypeID] = useState();
    useEffect(() => {
        console.log(props)
        getList()
    }, []);

    const getList = async () => {
        const apiUrls = `${baseURLV1}/pretype/${props.location.state.id}?page=1&limit=10000`;
        let token = localStorage.getItem("Token");

        await axios({
            method: "get",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => {
                console.log(res.data)
                setListpreType(res.data)
                console.log(listpreType)
            })
            .catch((err) => {
                if (err.response) {

                }
            });
    };

    const [stateItem_image_path, setStateItem_image_path] = useState({
        previewItem_image_path: null,
        rawItem_image_path: null,
        imageURLItem_image_path: null,
    });

    const AlertError = (message) => {
        Swal.fire("Alert", message, "error");
    };


    const handleChangeItem_image_path = async (e) => {
        if (e.target.files.length) {
            e.preventDefault();
            let file = e.target.files[0];
            var reader = new FileReader();
            e.target.value = '';
            //reader.readAsDataURL(file);
            handleImageUploadItem_image_path(file)
        }
    };
    const handleImageUploadItem_image_path = async (file) => {
        var formdata = new FormData();
        let token = localStorage.getItem("Token");
        formdata.append("multi-files", file, URL.createObjectURL(file));

        var requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
            headers: {

                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        fetch(`${baseURLV1}/upload/multiple-upload`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                let res = JSON.parse(result);
                setStateItem_image_path({
                    previewItem_image_path: null,
                    rawItem_image_path: null,
                    imageURLItem_image_path: null,
                });
                let fullPath = `${baseURL}/uploads/${res.data}`
                setItem_image_path(fullPath);
                setNameImageItem_image_path(fullPath);
            })
            .catch((error) => console.log("error", error));
    };


    const removeImageItem_image_path = async () => {
        setStateItem_image_path({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
        });
        setItem_image_path("");
    };

    const handleCancelUploadItem_image_path = () => {
        setStateItem_image_path({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
        });
    };

    const onSubmit = async () => {
        if (item_image_path == "" || item_image_path === undefined) {
            return AlertError("please insert pdf");
        }

        if (preTypeID == "" || preTypeID === undefined) {
            return AlertError("please insert Presentation Type");
        }
        var events = {
            pre_type_id: String(preTypeID),
            pdf_file_path: item_image_path,
            product_id: props.location.state.id
        };
        let apiUrls = `${baseURL}/api/v1/prefile`;
        let token = localStorage.getItem("Token");
        axios({
            method: "post",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            data: events,
        }).then(async (res) => {
            history.goBack();
        })
            .catch((err) => {
                Swal.fire(
                    "Alert",
                    "Your can not create presentation file. !! " + err,
                    "error"
                );
            });
    };



    return (
        <>
            <Card>
                <CardHeader title={"Create Presentation File"}></CardHeader>
                <CardBody>
                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Presentation Type" })}:{" "}
                        </p>
                        <select
                            as="select"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={preTypeID}
                            onChange={e => setPreTypeID(e.target.value)}
                        >
                            <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
                            {listpreType &&
                                listpreType.map((result, index) => {
                                    return (
                                        <option key={index} value={result.id}>
                                            {result.pre_type_name}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "PDF" })} : <br></br>

                        </p>
                        <div
                            className="d-flex"
                            style={{
                                width: "530px",
                            }}>
                            <input
                                name="item_image_path"
                                style={{
                                    flexGrow: "1",
                                    height: "38px",
                                    backgroundColor: "#F4F6F9",
                                    borderRadius: "5px",
                                    borderWidth: "0",
                                }}
                                value={item_image_path}
                            />

                            <span className="btn btn-primary btn-file wbt"
                                style={{
                                    whiteSpace: "nowrap",
                                    width: "fit-content"
                                }}>
                                {intl.formatMessage({ id: "104025", defaultMessage: "Upload/Edit" })}
                                <input type="file" onChange={handleChangeItem_image_path} />
                            </span>

                            <button
                                type="button"
                                className="btn btn-danger wbt"
                                onClick={removeImageItem_image_path}
                            >
                                {intl.formatMessage({ id: "104026", defaultMessage: "delete" })}
                            </button>
                        </div>
                    </div>

                    <div
                        className="form-inline"
                        style={{
                            marginBottom: "25px",
                        }}
                    >
                        <div
                            style={{
                                marginTop: "15px",
                                float: "left",
                                width: "20%",
                            }}
                        ></div>
                        <Link to="/PreTypeList">
                            <button type="button" className="btn btn-secondary wbt mr-5">
                                {intl.formatMessage({ id: "104047", defaultMessage: "Cancel" })}
                            </button>
                        </Link>
                        <button className="btn btn-primary" onClick={() => onSubmit()}>
                            {intl.formatMessage({ id: "104048", defaultMessage: "Save" })}
                        </button>
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
